import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { ComponentTierName, interestedPackageEnum, SensorsPackage } from '@/constants/enums';
import { checkInfoLockTierIsVisible } from '@/utils/util-functions';
import EPTierProtection from '@/comp/common/EPTierProtection';
import EPTierInfoIcon from '@/comp/common/EPTierInfoIcon';
import KPIBox from '@/comp/KPIBox/KPIBox';

const MapKPIBox = observer(({ kpi, stationStore }) => {
  const { t } = useTranslation();
  const { key, title, icon, value, unit, scale, tooltip, hideTooltip, targetValue } = kpi;

  return (
    <KPIBox
      key={key}
      title={title}
      icon={icon}
      value={value}
      unit={unit}
      scale={scale}
      tooltip={tooltip}
      collapsed={stationStore.isSidebarCollapsed}
      tierLockIsVisible={checkInfoLockTierIsVisible(ComponentTierName.MapView, title as SensorsPackage, stationStore)}
      tierInfo={
        <EPTierProtection componentName={ComponentTierName.MapView}>
          <span className="tier-span">
            <EPTierInfoIcon
              type={title as SensorsPackage}
              tooltipTitle={t('isCalculated', { metric: title })}
              tooltipTextPart1={t('toRecord', { field: key === 'power' ? 'performance' : key })}
              tooltipTextPart2={t('getSensorPackage')}
              tooltipWidth={key === 'pressure' ? 320 : key === 'flow' ? 310 : 330}
              emailRequestTypeOfInterestedPackage={interestedPackageEnum.SENSOR_PACKAGE}
              emailRequestButtonClicked={`${key} tooltip`}
              emailRequestWhichScreen={'MAP'}
            />
          </span>
        </EPTierProtection>
      }
      hideTooltip={hideTooltip}
      targetValue={targetValue}
    />
  );
});

export default MapKPIBox;
